export default {
  distanceToCampus: 'Yerleşkeye Uzaklık',
  invitationLastSentOn: 'Davetiyenin Son Gönderilme Tarihi',
  walletBalance: 'Bakiye',
  flexiShuttleUsers: 'flexiShuttle Kullanıcıları',
  flexiShuttleFlexiVanpoolUsers: 'flexiShuttle/flexiVanpool  Kullanıcıları',
  flexiCarUsers: 'flexiCar Kullanıcıları',
  mobilityChallenged: 'Engelli Desteği',
  emailNoSpaces: 'E-posta boşluk içeremez',
  userAgreementDate: 'KVKK Onay Tarihi',
  pregnant: 'Hamile',
  registrationDate: 'Kayıt Tarihi',
  shift: 'Vardiya',
  eligibleFor: 'Kullanım Hakları',
  drivingLicence: 'Ehliyet',
  currentModeCommute: 'Mevcut Mod',
  walkingDistance: 'Yürüme Mesafesi',
  travelDistance: 'Seyahat Mesafesi*',
  travelTime: 'Seyahat Süresi*',
  totalEmission: 'Toplam Emisyon*',
  line: 'Hat',
  basicInfo: 'Temel Bilgiler',
  workSystemInfo: 'İş & Sistem Bilgileri',
  commuteInfo: 'İşe Gidiş Geliş',
  supportRequests: 'Destek Talepleri',
  cardReads: 'Kart Okutma',
  badgeScans: 'Kart Okumaları',
  showCardReads: 'Kart Okutmaları Göster',
  addLevel: 'Seviye Ekle',
  level: 'Seviye',
  pleaseEnterEmail: 'Lütfen email girişi yapınız',
  received: 'İşleme alındı',
  solved: 'Çözüldü',
  assignAdmin: 'Admin Ata',
  personnelDeleted: 'Personel Silindi',
  welcomeEmail: 'Hoşgeldin Emaili',
  welcomeEmailWillBeSent: '{0} kullanıcıya {1} gönderilecek. Onaylıyor musunuz?',
  welcomeEmailWillBeSentNamed: '{0} adlı kullanıcıya {1} gönderilecek. Onaylıyor musunuz?',
  welcomeEmailSent: 'Hoşgeldin Emaili Gönderildi',
  usingService: 'Servis Kullanıyor',
  suspendForNearDemand: 'Talep Yoğunluğu Nedeniyle Askıya Al',
  suspensionFrom: 'Başlangıç',
  suspensionUntil: 'Bitiş',
  suspensionReasonLabel: 'Askı Sebebi',
  suspendedUntil: 'Askı Bitiş Tarihi',
  suspendedBy: 'Askıya Alan',
  suspendedBySystem: 'Sistem',
  suspensionReason: {
    cancellation: 'Tekrarlayan Geç İptaller',
    noShow: 'Binmedi',
    other: 'Diğer',
  },
  noSupportRequests: 'Görüntülenecek Destek Talebi Yok.',
  createdPersonnel: 'Personel Oluşturuldu',
  updatedPersonnel: 'Personel Güncellendi',
  addEmployee: 'Personel Ekle',
  downloadExcel: 'Lütfen şablonu indirin, çalışan verilerinizle doldurun ve buraya yükleyin.',
  confirmDeletePersonnel: '{0} adlı personeli silmek üzeresiniz. Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
  confirmDeletePersonnels: '{0} personeli silmek üzeresiniz. Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
  passwordValidationInfo:
    'Şifre en az 8 karakter uzunluğunda olmalı ve şunlardan en az üçünü içermeli: bir büyük harf, bir küçük harf, bir sayı, bir özel karakter ({symbols}).',
  userDeleted: 'Bu kullanıcı silindi !',
  flexiRideUsers: 'flexiRide Kullanıcıları',
  assistantAssigned: 'Asistan atandı.',
  assignAssistantToSelected: 'Asistan Ata',
  selectAssistant: 'Asistan Seçin',
  assistantRole: 'Asistan Rolü',
  ridersAssistant: 'Sorumlu Olduğu Personeller',
  assistedby: 'Asistanlar',
  assistantAdminEmail: 'Asistanlar',
  cantAssignThisUser: 'Bu asistan, seçilen personnelere atanamaz',
  assistant: 'Asistan',
  assistants: 'Asistan',
  addNewRider: 'Yeni Personel Ekle',
  addNewAssistant: 'Yeni Asistan Ekle',
  ridersAssistedBy: '{0} Sorumlu Olduğu Personneller',
  assistantsTo: '{0} Asistanları',
  searchPersonnel: 'Personel Ara',
  requiredNoteToEnterNote: 'Kullanıcının ulaşım hizmetleri ile ilgili özel bir tercihi varsa lütfen belirtin.',
  issueDate: 'Veriliş Tarihi',
  validThrough: 'Son Geçerlilik Tarihi',
  closePanel: 'Paneli kapatmak istediğinizden emin misiniz? Kaydedilmemiş tüm değişiklikler kaybolacaktır',
  flexiRideAssistant: 'flexiRide Assistant',
  assitanceDuePermanently: 'Kalıcı',
  assistanceDueUntil: 'Geçici',
  assistanceCategories: 'Engel Kategorileri',
  assistanceCategory: {
    WHEELCHAIR: 'Tekerlekli Sandalye',
    CRUTCHES: 'Kol Değnekleri',
    VISUAL_IMPAIREMENT: 'Görme Engelli',
    HEARING: 'İşitme Engelli',
  },
  affiliateCompany: 'Şirket',
  shiftType: {
    label: 'Çalışma Şekli',
    regular: 'Düzenli',
    variable: 'Vardiyalı',
  },
  shuttleShifts: {
    label: 'Servis Vardiyaları',
    placeholder: 'Kişinin kullanabileceği rota gruplarını seçiniz',
    tooltip:
      'Personel servisleriniz rezervasyon sistemiyle çalışıyorsa bu alanı boş bırakabilirsiniz. Eğer yolcular yönetici tarafından rota gruplarına eklendiğinde sistem tarafından otomatik olarak bir rota ve durağa atanmasını istiyorsanız bu alana yolcunun kullanabileceği rota gruplarını ekleyin.',
  },
  onDemandPrivateDetails: 'flexiRide Detayları',
  onDemandPrivateAssistant: 'flexiRide Asistanı',
  addressUpdated:
    'Personelin ev adresi güncellendi. Lütfen sistemin güncel rota önerilerini inceleyin ve gerekli atamaları tamamlayın.',
  viewRoutes: 'Rotaları Görüntüle',
  shuttleShiftsAdded:
    'Yeni eklenen ve rota grubu tanımı bulunan kullanıcılar için sistem en uygun rota ve durak eşleştirmelerini yapacaktır. Bu işlem birkaç dakika sürebilir. Önerilen rotaları daha sonra flexiShuttle Servis Kullanıcıları ekranında Eşleşmeler sekmesinde görebilirsiniz.',
  insufficientPrivileges: 'Bu kullanıcının bilgilerini görüntüleme yetkiniz bulunmamaktadır.',
  addGuaranteedRide: 'Yolculuk Hakkı Ekle',
  numberOfGuaranteedRides: 'Eklenecek Yolculuk Hakkı Sayısı',
  guaranteedRideRange: 'Lütfen {0} ile {1} arasında bir değer giriniz',
  addGuaranteedRideConfirm: 'Seçilen kullanıcılara {0} adet yolculuk hakkı eklemek istediğinize emin misiniz?',
  addGuaranteedRideSuccess: '{0} adet yolculuk hakkı başarıyla eklendi',
  guaranteedRidesLeft: 'Kalan Yolculuk Hakkı',
  guaranteedRideQuotaWarning:
    'Kullanıcılar maksimum {0} yolculuk hakkına sahip olabilir. Yeni haklar mevcut bakiyeyi bu limite kadar tamamlayacaktır.',
  someEmployeesNotEligibleForGuaranteedRide:
    'Seçilen personellerden bazıları Guaranteed Ride Home için uygun değil. Bu personeller atlanacaktır.',
};
